import { render, staticRenderFns } from "./PublicLocal.vue?vue&type=template&id=8ee8956e&scoped=true&"
import script from "./PublicLocal.vue?vue&type=script&lang=js&"
export * from "./PublicLocal.vue?vue&type=script&lang=js&"
import style0 from "./PublicLocal.vue?vue&type=style&index=0&id=8ee8956e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee8956e",
  null
  
)

export default component.exports